import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import { TabIndex } from '../types';

interface EmptyStateProps {
  activeTab: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ activeTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getEmptyStateMessage = () => {
    switch (activeTab) {
      case TabIndex.ACTIVE:
        return {
          title: t('courses.emptyState.active.title'),
          subtitle: t('courses.emptyState.active.subtitle'),
        };
      case TabIndex.EXPIRED:
        return {
          title: t('courses.emptyState.expired.title'),
          subtitle: t('courses.emptyState.expired.subtitle'),
        };
      default:
        return {
          title: t('courses.emptyState.default.title'),
          subtitle: t('courses.emptyState.default.subtitle'),
        };
    }
  };

  const { title, subtitle } = getEmptyStateMessage();

  return (
    <Box className={classes.emptyState} data-testid="courses-empty-state">
      <div className={classes.emptyStateIcon}>📚</div>
      <Typography variant="h5" className={classes.emptyStateTitle} data-testid="courses-empty-state-title">
        {title}
      </Typography>
      <Typography variant="body1" className={classes.emptyStateSubtitle}>
        {subtitle}
      </Typography>
    </Box>
  );
};
